
/**
 * Created by nijin on 6/6/17.
 */
import {Component, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify/index';
import {ApiKeyService} from '../../api-key.service';
@Component({
  selector: 'nuc-view-key',
  template: `
       <app-modal #popup>
  <div class="app-modal-header">
    <h3 class="modal-title">Active API Keys</h3>
  </div>
  <div class="app-modal-body">
    <ul class="activeKeyList">
      <li *ngFor="let key of keys; let i = index;">
        <div class="activeKeyHolder" >
          <h5 id="api-key_{{i+1}}">{{key.apiKey}}</h5>
          <span class="expiry" id="expiry-on" *ngIf="key.timeToLive > -1">Expires on {{key.timeToLive | datex :'DD MMMM YYYY  h:mm:ss A'}}</span>
        </div>
        <button *ngIf="key.timeToLive > -1" class="btn btn-secondary btn-red btn-expire" id="btn-exp" (click)="selectApiKeyForDelete(key.id)">Expire Immediately</button>
        <div class="expireDialog"  [ngClass]="{'active':idForDeletion == key.id}" *ngIf="key.timeToLive > -1">
          <p class="red" id="confirmation">Are you sure?</p>
          <div class="btns">
            <button class="btn btn-secondary-small" (click)="idForDeletion = null;" id="btn-no" [disabled]="isLoading">No</button>
            <button class="btn btn-secondary-small btn-red" id="btn-yes" 
                              [disabled]="isLoading"     (click)="deleteKey(key.id)">
                                     <span *ngIf="isLoading"><i class="fa fa-spinner"></i> </span>
                                     Yes
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-secondary" (click)="close()" [disabled]="isLoading" id="cancel">
        {{'COMMON.CLOSE' | translate}}</button>
    </div>
  </div>
</app-modal>`,
  styleUrls: ['./popup.scss']

})
export class ViewKeyComponent {

  isSubmitted = false;
  idForDeletion: number ;
  isLoading = false;

  @ViewChild ('popup') popup;
  @Output() onAccept: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onReject: EventEmitter<number> = new EventEmitter<number>();
  @Input() keys: any;

  constructor(private apikeyService: ApiKeyService,
              private notifier: NotificationBarService) {

  }

  open() {
    this.idForDeletion = null;
    this.popup.open();
  }

  close() {
    this.popup.hide();
  }

  deleteKey(id) {
    this.isLoading = true;
    this.apikeyService.deleteKey(id)
      .subscribe(response => {
        this.isLoading = false;
        const idx = this.keys.map(key => key.id).indexOf(id);
        this.keys.splice(idx , 1);
        this.notifier.create({type: NotificationType.Success, message: response.status.message});
        this.onAccept.emit(id);
         if (this.keys.length > 1)  {
           this.close();
         }

      }, res => {
        this.isLoading = false;
        this.notifier.create({type: NotificationType.Error, message: res});
      });
  }

  selectApiKeyForDelete(id) {
    this.idForDeletion = id;
  }
}




// WEBPACK FOOTER //
// ./src/app/accounts/api-key/modal/view.key.ts